import { render } from "./CreationPopUp.vue?vue&type=template&id=6ce882f6"
import script from "./CreationPopUp.vue?vue&type=script&lang=js"
export * from "./CreationPopUp.vue?vue&type=script&lang=js"

import "./CreationPopUp.vue?vue&type=style&index=0&id=6ce882f6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__